import React, { useEffect } from "react"
import { Steps } from "./step-library"
import { Container } from "@carrotfertility/carotene"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { CenteredLoadingIndicator } from "../../../views/molecules/Molecules"
import { useJourneyFlow } from "../../shared/JourneyFlowContainer"
import CarrotClient from "lib/carrot-api"
import Settings from "utils/CarrotConfig"
import { setInitialCarrotPlanChatRequested } from "components/carrot-plans/hooks/useCarrotPlanEmployeeSettings"
import { waitForMinimumDelay } from "../../../../utils/WaitForMinimumDelay"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const ViewName = Steps.PROCESS_CREATE_CARROT_PLAN

export default function ProcessInitialCarrotPlanChatRequestedStep(): JSX.Element {
  const { setNextStep } = useStateMachine(ViewName, null)
  const { setShowBackButton, setShowProgressTracker } = useJourneyFlow()

  async function saveCarrotPlansEnrollmentComplete(): Promise<void> {
    return client.completeCarrotPlansEnrollment()
  }

  useEffect(() => {
    setShowBackButton(false)
    setShowProgressTracker(false)
    waitForMinimumDelay(
      Promise.all([saveCarrotPlansEnrollmentComplete(), setInitialCarrotPlanChatRequested()]),
      1000
    ).then(() => setNextStep(ViewName, ""))
  }, [])

  return (
    <>
      <Container padding="large" stack="giant">
        <CenteredLoadingIndicator />
      </Container>
    </>
  )
}
